const Generator = {
    questions: [

        {
            question: 'Für welchen Wein ist das Ahrtal bekannt?',
            answers: ['*Rotwein', 'Schaumwein', 'Weißwein', 'Likörwein']
        },
        {
            question: 'Unter welchem Namen ist die Nordschleife des Nürburgrings bekannt?',
            answers: ['*Grüne Hölle', 'Roter Teufel', 'Blaues Wunder', 'Schwarzes Loch']
        },
        {
            question: 'Wie heißt die höchste Erhebung des Hunsrücks?',
            answers: ['*Erbeskopf', 'Idarkopf', 'Kahlheid', 'Friedrichskopf']
        },
        {
            question: 'Wie lang ist die "Lahn"?',
            answers: ['*244km', '326km', '198km', '348km']
        },
        {
            question: 'Wie heißt der Prädikatswanderweg an der Mosel?',
            answers: ['*Moselsteig', 'Rieslingpfad', 'Winzersteig', 'Rebenpfad']
        },
        {
            question: 'Wofür ist Idar-Oberstein über die Grenzen hinaus bekannt?',
            answers: ['*Edelsteine', 'Schuhe', 'Keramik', 'Gewürze']
        },
        {
            question: 'Wie heißt das größte existierende Weinfest der Welt?',
            answers: ['*Dürkheimer Wurstfest', 'Historisches Weinfest', 'Deutsches Weinfest', 'Fest des Neuen Weines']
        },
        {
            question: 'Welche Stadt in Rheinhessen ist gleichzeitig Landeshauptstadt von Rheinland-Pfalz?',
            answers: ['*Mainz', 'Koblenz', 'Trier', 'Kaiserslautern']
        },
        {
            question: 'Über welchem Fluss thront die Loreley?',
            answers: ['*Rhein', 'Ahr', 'Mosel', 'Lahn']
        },
        {
            question: 'Für welches Produkt ist die Region Westerwald besonders bekannt?',
            answers: ['*Keramik', 'Autoreifen', 'Wein', 'Baumwolle']
        },
        {
            question: 'Wie viele Regionen hat Rheinland-Pfalz?',
            answers: ['*10', '9', '13', '7']
        },
        {
            question: 'Welche Region ist die älteste Wein-Region in Rheinland-Pfalz?',
            answers: ['*Mosel', 'Romantischer Rhein', 'Rheinhessen', 'Pfalz']
        },
        {
            question: 'Welche Flüsse treffen sich am Deutschen Eck?',
            answers: ['*Rhein & Mosel', 'Nahe & Ahr', 'Kyll & Rhein', 'Saar &Lahn']
        },
        {
            question: 'Welcher Ort in Rheinland-Pfalz ist als einziger als ein Felke-Heilbad / Felke-Kurort ausgezeichnet?',
            answers: ['*Bad Sobernheim', 'Bad Breisig', 'Bad Bertrich', 'Bad Ems']
        },
        {
            question: 'In welchem Ort entspringt die Ahr, in dem der Ahr-Radweg auch startet?',
            answers: ['*Blankenheim', 'Bad-Neuenahr', 'Mayschoss', 'Ahrweiler']
        }
    ],
    getSet: function () {
        this.shuffle(this.questions);
        let set = [];
        for (let i = 0; i < 3; i++) {
            set.push(this.questions[i]);
            this.shuffle(set[i].answers);
        }
        return set;
    },
    shuffle: function (array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    }
}

export default Generator;



// WEBPACK FOOTER //
// ./src/components/QuestionGenerator.js